"use strict";

(function (window, document, com, undefined) {
    const init = function () {
        countdown.init();
        video.init();
        form.init();
    }
    init();

})(
    window,
    document,
    {
        helper,
        api,
        countdown,
        video,
        form
    },
    undefined
);